import React, { type ReactNode } from 'react';
import Link from 'next/link';
import { useTranslation } from 'next-i18next';
import { ClickTracking } from '@/components/ClickTracking';
import { PlusIcon } from '@/icons';
import { type ReturnZepIcon } from '@/icons/ZepIcon';
import { EmptyListState } from '@/shared/components/itemList/EmptyListState';
import { useSearchQuizQuery } from '@/shared/quizList/hooks/useSearchQuizQuery';
import { type QuizListType } from '@/shared/quizList/QuizListType';
import { Button } from '@/ui_v3';
type EmptyQuizListProps = {
  type: QuizListType;
  title?: string;
  description?: string;
  goToActionInfo?: {
    href: string;
    icon: ReturnZepIcon;
    label: string;
    target: '_blank' | '_open';
  };
  /**
   * 기본 CTA(링크 이동) 대신 쓸 액션. 넘기면 `goToActionInfo` 와 기본 트래킹을 건너뛴다.
   *
   * ⚠️ 액션을 아예 없애려면 `null` 을 넘긴다. 생략(`undefined`)은 기본 CTA 를 쓰겠다는 뜻이다.
   */
  actionSlot?: ReactNode;
  /** 기본 일러스트 대신 쓸 이미지. */
  imageSlot?: ReactNode;
};
export const EmptyQuizList = (props: EmptyQuizListProps) => {
  const {
    searchText
  } = useSearchQuizQuery();
  const {
    t
  } = useTranslation(['common']);
  const goToActionInfo: EmptyQuizListProps['goToActionInfo'] = props.goToActionInfo ?? {
    target: '_blank',
    href: '/build',
    icon: PlusIcon,
    label: t('common.makeQuiz')
  };
  const GotoActionIcon = goToActionInfo.icon;
  const emptyText = searchText ? t('quizList.empty.bySearch') : t('quizList.empty.byFilter');
  return <EmptyListState image={props.imageSlot ?? undefined} keyword={searchText} title={props.title ? props.title : emptyText} description={props.description ? props.description : t('quizList.empty.suggestion')} action={/* `??` 가 아니다 — `null`(액션 없음)과 생략(기본 CTA)을 갈라야 한다. */
  props.actionSlot !== undefined ? props.actionSlot : <ClickTracking eventName={props.type === 'myQuiz' ? 'create_quiz_empty_myquiz' : 'create_quiz_empty_public'}>
            <Button intent={'alternative'} variant={'outlined'} size={'lg'} rounded={'full'} asChild={true}>
              <Link href={goToActionInfo.href} target={goToActionInfo.target} prefetch={false}>
                <GotoActionIcon size={'md'} />
                {goToActionInfo.label}
              </Link>
            </Button>
          </ClickTracking>} data-sentry-element="EmptyListState" data-sentry-component="EmptyQuizList" data-sentry-source-file="EmptyQuizList.tsx" />;
};